export const dateFormat = [
  'DD/MM/YYYY',
  'DD-MM-YYYY',
  'YYYY/MM/DD',
  'YYYY-MM-DD',
];

export const formatYYYYMMDD = 'YYYY-MM-DD';
export const formatYYYYMMDDwithTime = formatYYYYMMDD + ' HH:mm';
